import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './TaskList.m.sass';
import TaskListHeader from '../TaskListHeader';
import TaskListItem from '../TaskListItem';
import NoTasks from './NoTasks';
var TaskList = function TaskList(_ref) {
  var list = _ref.list;
  var completedTasks = list.tasks.filter(function (x) {
    return x.task.completed;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(TaskListHeader, {
    title: list.title,
    totalCount: list.tasks.length,
    completedCount: completedTasks.length,
    expanded: list.expanded,
    onClick: list.toggleExpansion
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.list, list.expanded && styles.expanded)
  }, list.tasks.length === 0 && /*#__PURE__*/React.createElement(NoTasks, null), list.tasks.map(function (taskItem) {
    return /*#__PURE__*/React.createElement(TaskListItem, {
      key: taskItem.task.id,
      item: taskItem
    });
  })));
};
export default observer(TaskList);
//# sourceMappingURL=index.js.map
